import { withStyles } from "@material-ui/core/styles";

import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import {
	filterNoToggleButtonStyle,
	filterToggleButtonStyle,
	filterToggleGroupStyle,
} from "./filterToggleStyles";


export const buttonStyle = withStyles((theme) => ({
	root: filterToggleButtonStyle(theme),
}));

export const StyledToggleButton = buttonStyle(ToggleButton);


export const StyledNoToggleButton = withStyles((theme) => ({
	root: filterNoToggleButtonStyle(theme),
}))(ToggleButton);


export const buttonGroupStyle = withStyles({
	root: filterToggleGroupStyle,
});

export const FilterToggleButtonGroup = buttonGroupStyle(ToggleButtonGroup);
